import React from 'react'
import * as Antd from 'antd'
import { TimePickerProps } from 'antd/lib/time-picker'
import { css } from '@emotion/core'

export const TimePicker: React.FC<TimePickerProps> = ({ ...props }) => {
  return (
    <Antd.TimePicker
      css={css({
        width: 107,
        '> input': {
          borderRadius: 17,
          fontSize: 16,
          padding: '8px 20px',
          borderColor: '#CCCCCC',
        },
        '> span': {
          marginTop: -4,
          marginRight: 9,
          zIndex: 0,
          '> img': { width: 10 },
        },
      })}
      format={'HH:mm'}
      placeholder="00:00"
      allowClear={false}
      suffixIcon={<img src={require('@/static/images/arrow_down_yellow.svg')} />}
      {...props}
    />
  )
}
